import React from 'react';
import Icon, { GLYPHS } from '../../components/Icon';

const BackButton = props => (
  <button type="button" className="c-back-button" {...props}>
    <Icon glyph={GLYPHS.SLIDE_ARROW_LEFT} /> Back
  </button>
);
BackButton.propTypes = {
};
BackButton.defaultProps = {
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/app/kiosk/components/BackButton.jsx